import React, { Component } from "react";
import { connect } from "react-redux";
import { map } from "lodash";
import * as matchesActions from "../../_actions/matchesActions";
import * as profileActions from "../../_actions/profileActions";
import * as appActions from "../../_actions/appActions";
import InfiniteScroll from "react-infinite-scroller";
import UserWidgetContainer from "../Matches/UserWidgetContainer";
import Section from "../UI/Section";
import PageSubTitle from "../UI/PageSubTitle";
import getAcceptInvitations from "../../_selectors/matchesSelectors/getAcceptInvitations";
import getPeopleWhoLikedMe from "../../_selectors/matchesSelectors/getPeopleWhoLikedMe";
import getPeopleExpressedInterestInMe from "../../_selectors/matchesSelectors/getPeopleExpresesedInterestInMe";
import getMatchesLastResult from "../../_selectors/matchesSelectors/getMatchesLastResult";
import { updateObject } from "../../_utils";
import matchesConstants from "../../_constants/matchesConstants";
import getMyInterestsCount from "../../_selectors/userSelectors/getMyInterestsCount";
import HoverWidget from "../UI/HoverWidget";
class InterestedInMe extends Component {
  componentDidMount() {
    const {
      updateHeader,
      updateBreadcrumb,
      getPeopleExpressedInterestInMe,
      interestsCount,
      markAsRead
    } = this.props;
    updateHeader({
      title: "People Who Expresed Interest In Me",
      description: "Members who expressed interest in you"
    });
    updateBreadcrumb([
      { label: "Home", link: "/" },
      { label: "Interested In Me", link: "/search" }
    ]);
    getPeopleExpressedInterestInMe();
    if (interestsCount > 0) {
      markAsRead();
    }
  }
  componentWillUnmount() {
    const { clearMembers, clearPeopleExpressedInterestInMe } = this.props;
    clearMembers();
    clearPeopleExpressedInterestInMe();
  }
  loadMoreItems = page => {
    const { lastResult, loadMore, results } = this.props;

    loadMore({ lastResult });
  };
  render() {
    const { results, lastResult } = this.props;
    return (
      <Section>
        <InfiniteScroll
          pageStart={0}
          loadMore={this.loadMoreItems}
          hasMore={lastResult !== null}
          initialLoad={false}
          loader={
            <div
              className="loader"
              style={{
                height: "50px",
                background: "#4d4d4d",
                textAlign: "center",
                lineHeight: "50px",
                color: "#fff",
                fontSize: "1.5em",
                marginTop: "1em"
              }}
            >
              Please Wait
            </div>
          }
        >
          <div className="row">
            {results.length === 0 ? (
              <div className="dev-table">
                <HoverWidget
                  title="No Members"
                  text="List of all the members who expressed interest in your profile"
                  link="/search"
                  linkText="Start Exploring Members"
                  success
                />
              </div>
            ) : (
              map(results, result => (
                <div key={result.id} className="col-md-4">
                  <UserWidgetContainer user={result.userId} />
                </div>
              ))
            )}
          </div>
        </InfiniteScroll>
      </Section>
    );
  }
}
const mapStateToProps = (state, ownProps) => ({
  results: getPeopleExpressedInterestInMe(state),
  lastResult: getMatchesLastResult(state),
  interestsCount: getMyInterestsCount(state)
});

const mapDispatchToProps = dispatch => ({
  getPeopleExpressedInterestInMe: () =>
    dispatch(matchesActions.getPeopleExpressedInterestInMe()),
  clearMembers: () => dispatch(matchesActions.clearMatchedMembers()),
  clearPeopleExpressedInterestInMe: () =>
    dispatch(matchesActions.clearPeopleExpressedInterestInMe()),
  loadMore: payload =>
    dispatch(
      matchesActions.loadMoreSearchResults(
        updateObject(payload, {
          type: matchesConstants.GET_PEOPLE_EXPRESSED_INTEREST_IN_ME
        })
      )
    ),
  markAsRead: () => dispatch(matchesActions.markAllExpressedInterestsAsRead())
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(InterestedInMe);



// WEBPACK FOOTER //
// ./src/_components/InterestedInMe/index.js